var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"brdr-none bg-cl-transparent"},[_vm._v("\n  "+_vm._s(_vm.$t('Remove'))+"\n  "),_c('i',{staticClass:"icon-kosz_black h6"})])}
var staticRenderFns = []

export { render, staticRenderFns }